import { APP } from './tokens';
import FolderPickerButton from './FolderPickerButton';
import type { Folder } from '../../types';
import { Menu } from 'lucide-react';

interface TopBarProps {
  title?: string;
  folders?: Folder[];
  currentFolderId?: string | null;
  onAddToFolder?: (folderId: string) => void;
  onCreateFolder?: (name: string) => Promise<string> | string;
  onVersionHistory?: () => void;
  onDownload?: () => void;
  onMenu?: () => void;
  showActions?: boolean;
}

export default function TopBar({
  title = 'What are you working on?',
  folders = [],
  currentFolderId,
  onAddToFolder,
  onCreateFolder,
  onVersionHistory,
  onDownload,
  onMenu,
  showActions = true,
}: TopBarProps) {
  return (
    <div
      style={{
        height: APP.topBarHeight,
        display: 'flex',
        alignItems: 'center',
        flexShrink: 0,
        paddingInline: 16,
        gap: 8,
        borderBottom: `1px solid ${APP.border}`,
        fontFamily: APP.fontFamily,
        boxSizing: 'border-box',
      }}
    >
      {onMenu && (
        <button
          type="button"
          aria-label="Open navigation"
          onClick={onMenu}
          style={{
            width: 34,
            height: 34,
            display: 'grid',
            placeItems: 'center',
            borderRadius: 9,
            border: `1px solid ${APP.border}`,
            background: APP.bgVersionCard,
            color: APP.textPrimary,
            flexShrink: 0,
          }}
        >
          <Menu size={18} />
        </button>
      )}

      {/* Center title */}
      <div style={{ flexGrow: 1, flexShrink: 1, flexBasis: '0%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <span style={{ fontSize: 12, color: APP.textSecondary, lineHeight: '16px' }}>
          {title}
        </span>
      </div>

      {/* Right actions */}
      {showActions && <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
        {/* Add to folder */}
        <FolderPickerButton
          folders={folders}
          currentFolderId={currentFolderId}
          onSelect={(folderId) => onAddToFolder?.(folderId)}
          onCreateFolder={onCreateFolder}
        />

        {/* Version history */}
        <button
          type="button"
          className="btn-hover"
          onClick={onVersionHistory}
          style={{
            display: 'flex',
            alignItems: 'center',
            borderRadius: 5,
            padding: 5,
            background: 'none',
            border: 'none',
            cursor: 'pointer',
          }}
        >
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" style={{ flexShrink: 0 }}>
            <path d="M2.5 7.5 A4.5 4.5 0 1 0 7 2.5" stroke={APP.iconDefault} strokeWidth="1.3" strokeLinecap="round" />
            <path d="M2.5 4.5v3h3" stroke={APP.iconDefault} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>

        {/* Download */}
        <button
          type="button"
          className="btn-hover"
          onClick={onDownload}
          style={{
            display: 'flex',
            alignItems: 'center',
            borderRadius: 5,
            padding: 5,
            background: 'none',
            border: 'none',
            cursor: 'pointer',
          }}
        >
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" style={{ flexShrink: 0 }}>
            <path d="M7 2v7M4 6.5L7 10l3-3.5M2 11h10" stroke={APP.iconDefault} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
      </div>}
    </div>
  );
}
